import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/success-background.png';
const _withScopeId = n => (_pushScopeId("data-v-68e74368"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bg"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "content-image",
  src: _imports_0
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-text"
}, "您已提交成功", -1));
const _hoisted_5 = {
  class: "content-btn"
};
import { closeWebview } from '@/utils/navitiveApi/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessQuestion',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_MainButton = _resolveComponent("MainButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_MainButton, {
        onClick: _unref(closeWebview)
      }, {
        default: _withCtx(() => [_createTextVNode("返回")]),
        _: 1
      }, 8, ["onClick"])])])]);
    };
  }
});